import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const StockPill = ({ stock, initial, testId = "inventory-badge", dark = false }) => {
  const low = typeof stock === "number" && stock <= 0;
  const label = stock === 0 ? "Sold out" : "In stock · Ships in 1–2 days";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 font-mono-ghp text-[0.7rem] uppercase tracking-[0.14em] ${
        dark ? "border-white/15 bg-white/5 text-[#F2EAE1]" : "border-[#E3D9CD] bg-white/70 text-[#181615]"
      }`}
    >
      <span className={`pulse-dot h-1.5 w-1.5 rounded-full ${low ? "bg-[#EA580C]" : "bg-[#16A34A]"}`} />
      {label}
    </span>
  );
};
